// extracted by mini-css-extract-plugin
export default {"wrapper":"zjGk61j","legend":"C9rILJl","tooltipWrapper":"gWvSbtv","title":"xLNfxA8","valueWrapper":"AhVkbnv","value":"P9gvi0x","skeleton":"KlgSUW4","color":"Vvt7Q5o"};